module.exports = __webpack_public_path__ + "img/default-head.fc1da238.png";